// Read-only GitLab Flavored Markdown renderer. Used by the issue page
// to display the saved description and by the chat to render assistant
// turns. `remark-gfm` handles tables, task-list checkboxes (with the
// rendered `<input type="checkbox" disabled />` form), strikethrough,
// and autolinks.

import { type JSX } from "react";
import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

interface MarkdownViewProps {
  readonly source: string;
  readonly className?: string;
  /** Extra component overrides merged over the default link handling
   *  (e.g. the loom-confirm fence interception for assistant turns). */
  readonly components?: Components;
}

export const MarkdownView = ({
  source,
  className,
  components,
}: MarkdownViewProps): JSX.Element => (
  <div className={`md-view ${className ?? ""}`.trim()}>
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ children, href }) => (
          <a href={href} target="_blank" rel="noreferrer">
            {children}
          </a>
        ),
        ...components,
      }}
    >
      {source}
    </ReactMarkdown>
  </div>
);
